import { trackEvent } from '@cx-web/utils/dataLayer';

import { type Tipster } from '~/api/tipsters/types';

export const trackTipsterProfileClick = ({ sport, tipster }: { sport: string; tipster: Tipster['name'] }) => {
  trackEvent('tipster_profile', {
    eventLabel: 'Tipster Profile Click',
    tipsterName: tipster,
    sport: sport,
  });
};

export const trackActiveTipsClick = ({
  napOfTheDay,
  position,
  selectionRate,
  sport,
  tipster,
}: {
  napOfTheDay: boolean;
  position: number;
  selectionRate: string;
  sport: string;
  tipster: Tipster['name'];
}) => {
  trackEvent('active_tips', {
    eventLabel: 'Active Tips Click',
    selectionRate,
    position,
    tipster: tipster,
    sport: sport,
    napOfTheDay,
  });
};

export const trackTipstersMenuClick = ({ selection }: { selection: string }) => {
  trackEvent('tipsters_menu', {
    eventLabel: 'Tipsters Menu Click',
    selection,
  });
};

export const trackTipstersOddsClick = ({
  bestOdds,
  betName,
  market,
  napOfTheDay,
  returnValue,
  sport,
  stake,
  tipster,
}: {
  bestOdds: string | number;
  betName: string;
  market: string;
  napOfTheDay: boolean;
  returnValue: number;
  sport: string;
  stake: number;
  tipster: string;
}) => {
  trackEvent('tipsters_odds', {
    eventLabel: 'Tipsters Odds Click',
    tipster,
    betName,
    market,
    sport,
    bestOdds,
    stake,
    return: returnValue,
    napOfTheDay,
  });
};
